import Vue from 'vue';

const state = {};
const actions = {
    printLabel: (context, productIds) => {
        Vue.prototype.$loader.show();
        return axios.post('/api/prints/label', productIds)
            .then(response => {
                Vue.prototype.$toast.success('Impressão realizada com sucesso');
                return response;
            })
            .catch(error => {
                Vue.prototype.$toast.error('Erro ao imprimir');
                throw error;
            })
            .finally(() => Vue.prototype.$loader.hide());
    },
    printCustomerQR: (context, id) => {
        Vue.prototype.$loader.show();
        return axios.post('/api/prints/customer-qr', { customer_id: id })
            .then(response => {
                Vue.prototype.$toast.success('Impressão realizada com sucesso');
                return response;
            })
            .catch(error => {
                Vue.prototype.$toast.error('Erro ao imprimir');
                throw error;
            })
            .finally(() => Vue.prototype.$loader.hide());
    },
    printContact: (context) => {
        Vue.prototype.$loader.show();
        return axios.post('/api/prints/contact')
            .then(response => {
                Vue.prototype.$toast.success('Impressão realizada com sucesso');
                return response;
            })
            .catch(error => {
                Vue.prototype.$toast.error('Erro ao imprimir');
                throw error;
            })
            .finally(() => Vue.prototype.$loader.hide());
    },
    printConference: (context, key) => {
        Vue.prototype.$loader.show();
        return axios.post('/api/prints/conference', { access_key: key })
            .then(response => {
                Vue.prototype.$toast.success('Impressão realizada com sucesso');
                return response;
            })
            .catch(error => {
                Vue.prototype.$toast.error('Erro ao imprimir');
                throw error;
            })
            .finally(() => Vue.prototype.$loader.hide());
    },
    printReceipt: (context, orderId) => {
        Vue.prototype.$loader.show();
        return axios.post(`/api/prints/receipt/${orderId}`)
            .then(response => {
                Vue.prototype.$toast.success('Impressão realizada com sucesso');
                return response;
            })
            .catch(error => {
                Vue.prototype.$toast.error('Erro ao imprimir');
                throw error;
            })
            .finally(() => Vue.prototype.$loader.hide());
    },
    printLastReceipt: (context) => {
        Vue.prototype.$loader.show();
        return axios.post('/api/prints/receipt/last')
            .then(response => {
                Vue.prototype.$toast.success('Impressão realizada com sucesso');
                return response;
            })
            .catch(error => {
                Vue.prototype.$toast.error('Erro ao imprimir');
                throw error;
            })
            .finally(() => Vue.prototype.$loader.hide());
    },
};
const mutations = {};
const getters = {};
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};